<template>
 <div class="row mt-4 mb-2 font-weight-bold" style="font-size: 16px; text-decoration: underline;"> {{ $t('demand.tabs.summary.vehicle.label') }}</div>
  <div v-for="orderItem in orderItems" :key="orderItem.resourceUid">
    <div class="row">
        <div class="col-7">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.vehicle.brand') }}
            
          </label>
          <span class="font-weight margin-left color" >
            {{getAssets(orderItem).brand}}
          </span>
        </div>
        <div class="col-2">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.vehicle.color') }}
            
          </label>
          <span class="font-weight margin-left color" >
            {{getAssets(orderItem).color}}
          </span>
        </div>
         <div class="col-3">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.vehicle.matriculation') }}
            
          </label>
          <span class="font-weight margin-left color" >
            {{getAssets(orderItem).matriculation}}
          </span>
        </div>
    </div>   
     <div class="row">
        <div class="col-3">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.vehicle.NumFab') }}
            
          </label>
          <span class="font-weight margin-left color" >
                {{getAssets(orderItem).numFab}}   
          </span>
        </div>
        <div class="col-4">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.vehicle.chassis') }}
            
          </label>
          <span class="font-weight margin-left color"  v-html="getChassisLink(orderItem)">

          </span>
        </div>
        <div class="col-2">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.vehicle.energie') }}
            
          </label>
          <span class="font-weight margin-left color" >
              {{getAssets(orderItem).engineType}}
          </span>
        </div>
        <div class="col-3">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.vehicle.matriculationDate') }}
            
          </label>
          <span class="font-weight margin-left color" >
              {{getAssets(orderItem).matriculationDate}}
          </span>
        </div>
    </div>       
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";


@Options({
  props: ["orderItems"],
  components: {
  },
})
export default class summaryTabOrderVehicle extends Vue {
  orderItems?: Array<any>;
    getAssets(orderItem: any) {
    let assetInfo: any = {}
    const asset = orderItem && orderItem.orderAssets && orderItem.orderAssets.length
            ? orderItem.orderAssets.filter((asset:any)=> asset.assetTradeIn === null)[0]
            : null;
    const brand = asset.brand ? asset.brand.replace(/asset.good.vehicle.brand./g, "")   : "-"
    const range = asset.range && asset.range.includes('range.') ? asset.range.substring(asset.range.lastIndexOf(".") + 1) : asset.range ? asset.range : "-" ;
    const version = asset.version && asset.version.includes('range.') ? asset.version.substring(asset.version.lastIndexOf("range") + 6) : asset.version ? asset.version : "-" ;
    const color = asset.color ? asset.color : "-"
    const chassisReference = asset.chassisReference ? asset.chassisReference : "-"
    const engineType = asset.engineType ? asset.engineType.replace(/asset.good.vehicle.energytype./g, "")  : "-"
    const matriculation = asset.matriculation ? asset.matriculation : "-"   
    const matriculationDate = asset.matriculationDate ? asset.matriculationDate : "-"   
    assetInfo = {
      "brand": brand+" "+range+" "+version,
       "color":color,
        "chassisReference": chassisReference,
        "engineType": engineType,
        "matriculation": matriculation,
        "matriculationDate": matriculationDate,
        "numFab": "-"
      }
   return assetInfo 
  }

  getChassisLink(orderItem: any) {
    const brand = this.getAssets(orderItem).brand.toLowerCase();
    const chassisReference = this.getAssets(orderItem).chassisReference;
    if (["renault", "dacia", "alpine"].some(b => brand.includes(b)) && chassisReference !== "-") {
      const url = `https://dcs.renault.com/icm/jsp/ServletLogin?VIN=${chassisReference}&KM=10`;
      return `<a href="${url}" target="_blank">${chassisReference}</a>`;
    }
    return chassisReference;
  }
}
</script>

<style scoped>
</style>
